import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import enAuTranslation from './locales/en-AU/translation.json';
import enGbTranslation from './locales/en-GB/translation.json';
import { Locale } from './locales/locale.ts';
import { i18nAlias } from './i18n-alias.ts';

export const defaultNS = 'translation';
export const resources = {
  en: {
    translation: enTranslation,
  },
  [Locale.EN_US]: {
    translation: enTranslation,
  },
  [Locale.EN_AU]: {
    translation: enAuTranslation,
  },
  [Locale.EN_GB]: {
    translation: enGbTranslation,
  },
} as const;

i18n
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  .use(i18nAlias)
  .init({
    debug: false,
    fallbackLng: 'en',
    returnNull: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    defaultNS,
    supportedLngs: ['en', Locale.EN_US, Locale.EN_GB, Locale.EN_AU],
    parseMissingKeyHandler: (key) => {
      return `[[MISSING KEY: ${key}]]`;
    },
    resources,
    postProcess: ['i18nAlias'],
  });
